site.hero = {
	init:function() {
		if (!$('body').hasClass('frontpage')) return false;
		if ($('#hero li').length > 1) {
			site.owl.init('#hero > ul', {
				loop: true,
				dots: false,
				nav: true,
				items: 1,
				navText: ["", ""],
				stopOnHover: true,
				autoplay: true,
				autoplayTimeout: 8000,
				autoplayHoverPause: true,
				animateOut: 'fadeOut',
				animateIn: 'fadeIn',
				onDrag: function () {
					$('#hero .owl-controls').hide();
				},
				onDragged: function () {
					$('#hero .owl-controls').show();
				},
				onInitialized: function() {
					$('#hero .owl-dot').keydown(function (e) {
						if (e.which == 13) {
							$(e.target).click();
						}
					});
				},
				onTranslated: function() {
					$('#hero .owl-item a').attr('tabindex', '-1');
					$('#hero .owl-item.active a').attr('tabindex', '4');
				}
			});
		}

		if ($('#carousel li').length > 1) {
			site.owl.init('#carousel > ul', {
				loop: true,
				dots: false,
				nav: true,
				navText: ["", ""],
				margin:15,
				responsive:{
					// breakpoint from 0 up
					0:{
						items:1
					},
					// breakpoint from 480 up
					480:{
						items:3
					},
					// breakpoint from 768 up
					768:{
						items:4
					},
					// breakpoint from 992 up
					992:{
						items:5
					},
					// breakpoint from 1200 up
					1200:{
						items:7
					}
				}
			});
		}
	}
};


site.store = {
	init: function () {
		$('body').on('click', '#storeCart .showMore', function (e) {
			e.preventDefault();
			$('body').toggleClass('cart-open');

			$('body.cart-open').on('click', function (e) {
				if (!$(e.target).parents('#storeCart').length) {
					$('body').removeClass('cart-open');
				}
			});
		});

		if ($('body').hasClass('productView')) {
			$('ul.albumImages .productImage.first').addClass('active');

			$('ul.albumImages .productImage').on('click', function (e) {
				if (!this.classList.contains('active')) {
					$('ul.albumImages .productImage.active').removeClass('active');
					this.classList.add('active');
				}
			});

			// if ($fieldset.hasClass('disabled')) {
			// 	$fieldset.find('input:not(.checkbox)').attr('disabled', 'disabled');
			// }
			// else {
			// 	$fieldset.find('input:not(.checkbox)').attr('disabled', null);
			// }
		}

		//Store
		if ($('body').hasClass('store')) {
			site.owl.init('.product .albumImages', {
				loop: false,
				dots: false,
				nav: true,
				items: 4,
				navText: ["", ""],
				margin: 20,
				responsive: {
					// breakpoint from 0 up
					0:{
						items:1
					},
					// breakpoint from 480 up
					480:{
						items:2
					},
					// breakpoint from 1200 up
					1200:{
						items:3
					}
				}
			});

			$('.like, .pin', '.product .social').click(function(){
				$(this).toggleClass('open');
			});
		}

		//Checkout
		if ($('body').hasClass('checkout')) {
			$('#billing-billingSameAsShipping').change(function() {
				var $fieldset = $('#fieldset-billing').toggleClass('disabled');
				if ($fieldset.hasClass('disabled')) {
					$fieldset.find('input:not(.checkbox)').attr('disabled', 'disabled');
				}
				else {
					$fieldset.find('input:not(.checkbox)').attr('disabled', null);
				}
			}).change();

			$('ul.paymentTypeSelection li').click(function(){
				$(this).siblings().removeClass('selected');
				$(this).addClass('selected');
			});
		}
	}
};

site.inits.push('site.hero.init()');
site.inits.push('site.store.init()');

store = window.store || {};
store.local = store.local || {};
store.local.onUpdateVariantData = function(variant) {
	var attributes = '';
	$.each(variant.attributes, function(attrIdx, attr) {
		attributes += attr + ' / ';
	});
	attributes = attributes.substr(0, attributes.length - 3);

	$('.product .attributes').html(attributes);
};

store.local.updateMiniCart = function() {
	$.get(store.url(store.action.cartMedium, ''), function (data) {
		$('.cartBoxMedium').replaceWith(data.html);
	}, 'json');
	$.get(store.url(store.action.cartBox, ''), function (data) {
		$('.miniCart').replaceWith(data.html);
	}, 'json');
};

store.local.onAddToCart = function() {
	store.local.updateMiniCart();
};

store.local.onCartIncrease = function() {
	store.local.updateMiniCart();
};

store.local.onCartDecrease = function() {
	store.local.updateMiniCart();
};

store.local.initAlbumImages = function() {
	$('ul.albumImages a').click(function(e) {
		e.preventDefault();
		$href = $(this).attr('href');
		$src = $(this).data('image');
		$image = $('.images .image');

		if ($src != $('img', $image).attr('src')) {
			$image.append('<div class="loading">')
			$('a', $image).attr("href", $href);
			$('img', $image).attr("src", $src).load(function() {
				$('.loading',$image).remove();
			});
		}
	});
};